import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "drv-text-body-sm" }
const _hoisted_2 = ["href"]

import { computed } from "vue";
import { useHelpLinkFeature } from "../../../composables";
import { ETelematicsMessagesKeys } from "../../../types";


export default /*@__PURE__*/_defineComponent({
  __name: 'HelpLink',
  props: {
    link: {}
  },
  setup(__props: any) {

const props = __props;

const { isLinkExternal, onHelpLinkClick } = useHelpLinkFeature();

const isExternal = computed<boolean>(() => {
  return isLinkExternal(props.link);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.link)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (isExternal.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.link,
                target: "_blank"
              }, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).BASE_TOKEN_SUBTITLE_URL_TITLE)), 9, _hoisted_2))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: '',
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(onHelpLinkClick)(_ctx.link)), ["prevent"]))
              }, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).BASE_TOKEN_SUBTITLE_URL_TITLE)), 1))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})